import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import SettingsContext from '../settings_context';
import Option from './option';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

import './styles.scss';

export function Options({ options, reorderable, selected, onOptionClick, onOptionMove }) {
  const settings = useContext(SettingsContext);

  const [dragIndex, setDragIndex] = useState();
  const [dropIndex, setDropIndex] = useState();

  return (
    <div className="options w-100">
      {options.map((option, i) => (
        <Option
          index={i}
          key={option[settings.optionValueName]}
          option={option}
          optionLabelName={settings.optionLabelName}
          optionValueName={settings.optionValueName}
          removable={option.hasOwnProperty('locked') ? !option.locked : true}
          reorderable={reorderable}
          selected={selected}
          targeted={i === dropIndex}
          onBeginDrag={setDragIndex}
          onClick={onOptionClick}
          onEndDrag={() => onOptionMove(dragIndex, dropIndex)}
          onReorder={(_, dropIndex) => setDropIndex(dropIndex)}
        />
      ))}
    </div>
  );
}

Options.propTypes = {
  options: PropTypes.array.isRequired,
  reorderable: PropTypes.bool,
  selected: PropTypes.bool,
  onOptionClick: PropTypes.func.isRequired,
  onOptionMove: PropTypes.func,
};

export default reorderableList(Options);
